<div class="mass-upload-grid-dashboard">
  @if (errorMessage) {
    <div class="error-message">
      <p>{{ errorMessage }}</p>
    </div>
  }

  @if (hasEntitlement) {
    @if (numCasesInProgress > 0 || numCasesSubmitted > 0) {
      <div class="data-card-container">
        <app-data-display-card cardTitle="In Progress" theme="IN_PROGRESS" [dataValue]="numCasesInProgress"></app-data-display-card>
        <app-data-display-card cardTitle="Submitted" theme="DEFAULT" [dataValue]="numCasesSubmitted"></app-data-display-card>
      </div>
    }

    <div class="dashboard-container">
      <div class="button-container">
        <button mat-raised-button color="primary" class="submit-button" (click)="createNewCase()">
          Create New Case
        </button>
        <button mat-raised-button color="primary" class="submit-button" (click)="showAllSubmissions()">
          View All Submitted Applications
        </button>
      </div>

      <div class="ag-grid-container">
        <ag-grid-angular
          #agGrid
          [columnDefs]="columnDefs"
          [gridOptions]="gridOptions"
          [pagination]="true"
          [paginationPageSize]="paginationPageSize"
          [cacheBlockSize]="cacheBlockSize"
          [rowModelType]="'infinite'"
          (gridReady)="onGridReady($event)"
        ></ag-grid-angular>

        @if (isLoading) {
          <div class="loading-mask">
            <mat-spinner diameter="100"></mat-spinner>
          </div>
        }
      </div>
    </div>
  }
</div>
